export type TooltipPlacement = "top" | "bottom";

export type TooltipSnapshot = {
    anchorEl: HTMLElement | null;
    message: string;
    to?: string;
    placement: TooltipPlacement;
};

export const getTooltipSnapshot = (
    open: boolean,
    lastOpenTooltipSnapshotRef: TooltipSnapshot | null,
    currentSnapshot: TooltipSnapshot
): TooltipSnapshot => {
    if (open) return currentSnapshot;
    return lastOpenTooltipSnapshotRef ?? currentSnapshot;
};
